import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card, CardBody, CardFooter, CardHeader, Container, Row, Col,
} from 'reactstrap';
import PropTypes from 'prop-types';
import SignupForm from './SignupForm';
import submit from './submit';
import userconnect from './userconnect';
import EmailInput from './EmailInput';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  user: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
  }).isRequired,
  onLogin: PropTypes.func.isRequired,
};

const defaultProps = {};

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      locationLoading: false,
      isValid: true,
      data: {
        password: '',
        email: '',
      },
    };
    this.submit = submit.bind(this, { name: 'login', url: 'local' });
  }

  onMessage(message) {
    this.setState({ message });
  }

  render() {
    const { props } = this;
    const { user } = props;
    if (user && user.isAuthenticated) {
      props.history.push('/');
    }
    const { state } = this;
    return (
      <div className="login">
        <Container>
          <div className="d-flex justify-content-center h-100">
            <Card>
              <SignupForm title="Login" onMessage={this.onMessage} onLogin={this.onLogin} />
              <CardBody>
                <form onSubmit={this.submit} method="post">
                  <EmailInput
                    value={state.data.email}
                    onChange={(event) => {
                      const { data } = state;
                      data.email = event.target.value;
                      this.setState({ data });
                    }}
                  />
                  <div className="input-group form-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text"><i className="fas fa-key" /></span>
                    </div>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="password"
                      name="password"
                      value={state.data.password}
                      onChange={(event) => {
                        const { data } = state;
                        data.password = event.target.value;
                        this.setState({ data });
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <button
                      type="submit"
                      className={`btn float-right login_btn ${state.isValid ? '' : 'btn-link'}`}
                    >
                      <i className={`fas ${state.locationLoading ? 'fa-spinner spin-animate' : 'fa-user'}`} />
                      {' '}
                      Log in
                    </button>
                  </div>
                </form>
              </CardBody>
              <CardFooter>
                <div className="d-flex justify-content-center links">
                  Don&apos;t have an account?
                  <Link to="/user/signup">Sign Up</Link>
                </div>
                <div className="d-flex justify-content-center">
                  <Link to="/user/forgot-password">Forgot your password?</Link>
                </div>
              </CardFooter>
            </Card>
            <div className={`alert alert-login${state.message ? '' : ' alert-hidden'}`} role="alert">
              <i className="fas fa-exclamation-circle" />
              {' '}
              {state.message}
            </div>
          </div>
        </Container>
        <Container>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h2>Gym Navigator User Area</h2>
                </CardHeader>
                <CardBody>
                  <p>Rate your favorite gyms, exercises and routines.</p>
                  <p>Help other and mark available amenities on gyms which you know.</p>
                  <p>Track your gym activities.</p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

Login.propTypes = propTypes;
Login.defaultProps = defaultProps;

export default userconnect(Login);
